import { PurseType } from 'types/enums';
import { isCrypto } from './isCrypto';

export function formatAmount(amount: number, currency?: PurseType): string {
    const displayOptions = {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    };

    if (currency && isCrypto(currency)) displayOptions.maximumFractionDigits = 8;

    return Intl.NumberFormat('ru-RU', displayOptions).format(amount).replace(/,/, '.');
}
